import { apiResultSuccess, deleteToDoItem, markTodoItemDone } from "../apihelper";
import { isAFunction } from "../global/utils";
import TodoItem from "../models/todo-item";
import ModuleController from "./ModuleController";

export default class TodoItemController extends ModuleController {
    constructor(item) {
        super();
        this.item = item;
        this.animate = false;
        this.deleteAction = false;
    }

    getItem() {
        return this.item;
    }

    setItem(newItem) {
        this.item = newItem;
    }

    // Creates new TodoItem from editData
    // Runs reload on subject
    editItem(editData={}) {
        this.item = new TodoItem(editData);
        this.subject.runReload();
    }

    setDeleteAction(successFn=false) {
        if ( isAFunction(successFn) ) {
            this.deleteAction = successFn;
        }
    }

    // Marks item done calling API markTodoItemDone fn
    // Updates item with new data using editItem
    markDone() {
        this.item.toggleDoneState();

        markTodoItemDone(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( results.todo_item ) {
                        this.editItem(results.todo_item);
                    }
                } 
            }, this.item.getId(), this.item.getDone()
        )
    }

    deleteSelf() {
        const id = this.item.getId();
        const postData = { id: id };

        deleteToDoItem(
            (results) => {
                if ( apiResultSuccess(results) ) {
                    if ( this.deleteAction ) {
                        this.deleteAction(id);
                    } 
                } 
            }, postData
        )
    }
}